import { render, staticRenderFns } from "./ForgottenPasswordDialog.vue?vue&type=template&id=de99c912&scoped=true"
import script from "./ForgottenPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./ForgottenPasswordDialog.vue?vue&type=script&lang=ts"
import style0 from "./ForgottenPasswordDialog.vue?vue&type=style&index=0&id=de99c912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de99c912",
  null
  
)

export default component.exports